module.exports = __webpack_public_path__ + "img/nofar-avatar@3x.5ff10c47.png";